module.exports = __webpack_public_path__ + "static/img/ecodiplomatica.7185dac7.png";